export const mockMonitorRealTimeList = function () {
  return [
    {
      tab: 0,
      carrier: {
        id: 1646,
        create_time: 1701237263245,
        update_time: 1703040861598,
        update_user: 79,
        create_user: 15,
        scene_id: 22,
        keycode: '1129冰箱',
        description: '1',
        status: 0,
        typeId: 2,
        code: '0762f49f994245b987ba9d942e254836',
        abnormal: 0,
        alarm_switch: 1,
        alarm_bind: 1,
        is_trace: 1,
        sample_value: '{"hum":[{"val":30.6,"code":"hum","min":20.0,"max":80.0,"rangeName":"sh-常湿","itemMap":[{"val":30.6,"no":"温湿度计40542","catalog":0,"id":"3617b0e8e9db4a089899f92211638458","time":1703484381000,"type":2,"status":1}],"time":1703484354607,"isRange":0}],"temp":[{"val":23.08,"code":"temp","min":20.0,"max":36.0,"rangeName":"sh-常温","itemMap":[{"val":23.08,"no":"温湿度计40542","catalog":0,"id":"3617b0e8e9db4a089899f92211638458","time":1703484381000,"type":2,"status":1}],"time":1703484354607,"isRange":0}]}',
        sample_strategy: 1,
        mode: 1,
        structureId: 267,
        structureName: '0621地图',
        scopeName: 'shawnee',
        fullPath: 'shawnee/单元架构/0621地图',
        statusCode: 'run',
        statusName: '运行',
        typeName: '冰箱',
        carrierExtend: {
          carrier_id: 1646,
          picture: '/usr/local/server/CCDC/devAlpha/core/webapps/ROOT/WEB-INF/core_platform-1.0/picture/carrierType/f0d3f633e20447b1a5685dbfb5cc9c08.jpeg',
          pictureBase64: ''
        },
        carrierDevice: {
          deviceList: [
            {
              carrier_device_id: 446,
              carrier_device_code: '3617b0e8e9db4a089899f92211638458',
              carrier_device_name: '温湿度计40542',
              device_catalog: 0,
              device_id: 1251,
              device_code: 'VMRTA40542',
              device_status: 1,
              device_type: 2,
              device_edited: 1,
              probe: '52,67',
              ranges: [
                {
                  id: 52,
                  create_time: 1652665803439,
                  update_time: 1652665803439,
                  update_user: 1,
                  create_user: 1,
                  name: 'sh-常温',
                  scope_id: 22,
                  unit_id: 1,
                  min: 20.0,
                  max: 36.0,
                  unit_name: '℃',
                  unit_code: 'temp'
                },
                {
                  id: 67,
                  create_time: 1656467553475,
                  update_time: 1656467553475,
                  update_user: 15,
                  create_user: 15,
                  name: 'sh-常湿',
                  scope_id: 22,
                  unit_id: 2,
                  min: 20.0,
                  max: 80.0,
                  unit_name: '%RH',
                  unit_code: 'hum'
                }
              ],
              probe_value: '{"hum":{"val":30.6,"time":1703484621000},"batt":{"val":3.285,"time":1703484621000},"temp":{"val":23.14,"time":1703484621000},"rssi":{"val":-34,"time":1703484621000},"lqi":{"val":252,"time":1703484621000}}'
            },
            {
              carrier_device_id: 358,
              carrier_device_code: '236be4577d0d4d6f91b64150977e5f7d',
              carrier_device_name: '网关7511',
              device_catalog: 1,
              device_id: 21,
              device_code: 'gwName7511',
              device_status: 1,
              device_type: 2,
              device_edited: 1,
              probe: ''
            }
          ],
          isRangeList: [
            {
              rangeName: 'sh-常温',
              unitName: '℃',
              code: 'temp',
              isRange: 0,
              max: 36.0,
              min: 20.0,
              sensorProbeList: [
                {
                  carrier_device_id: 446,
                  carrier_device_catalog: 0,
                  probe: '{"hum":{"val":30.6,"time":1703484621000},"batt":{"val":3.285,"time":1703484621000},"temp":{"val":23.14,"time":1703484621000},"rssi":{"val":-34,"time":1703484621000},"lqi":{"val":252,"time":1703484621000}}',
                  sensor_status: 1,
                  sensor_type: 2,
                  carrier_device_code: '3617b0e8e9db4a089899f92211638458',
                  carrier_device_name: '温湿度计40542'
                }
              ]
            },
            {
              rangeName: 'sh-常湿',
              unitName: '%RH',
              code: 'hum',
              isRange: 0,
              max: 80.0,
              min: 20.0,
              sensorProbeList: [
                {
                  carrier_device_id: 446,
                  carrier_device_catalog: 0,
                  probe: '{"hum":{"val":30.6,"time":1703484621000},"batt":{"val":3.285,"time":1703484621000},"temp":{"val":23.14,"time":1703484621000},"rssi":{"val":-34,"time":1703484621000},"lqi":{"val":252,"time":1703484621000}}',
                  sensor_status: 1,
                  sensor_type: 2,
                  carrier_device_code: '3617b0e8e9db4a089899f92211638458',
                  carrier_device_name: '温湿度计40542'
                }
              ]
            }
          ]
        }
      }
    }
  ]
}
